<template>
  <Transition name="fade">
    <div v-if="sliders.length" class="banner">
      <el-carousel height="320px">
        <el-carousel-item v-for="item in sliders" :key="item._id">
          <RouterLink target="_blank" :to="`${item.bannerUrl}`">
            <img v-lazy="item.bannerImg" alt="" />
          </RouterLink>
        </el-carousel-item>
      </el-carousel>
    </div>
    <TestsBannerSkeleton v-else />
  </Transition>
</template>

<script>
import TestsBannerSkeleton from "./test-banner-skeleton.vue";
import { findBanner } from "@/api/home";
import { ref } from "vue";
export default {
  name: "TestBanner",
  components: {
    TestsBannerSkeleton,
  },
  setup() {
    const sliders = ref([]);
    findBanner(1719395170423)
      .then((data) => {
        sliders.value = data;
      })
      .catch((error) => {
        console.log(error);
      });
    return { sliders };
  },
};
</script>

<style lang="less" scoped>
a {
  img {
    width: 1920px;
    height: 320px;
  }
}
</style>
